import { useCallback } from "react";
import { toast } from "sonner";
import { errMsg } from "./api";

export function useOrderActions(req, reload, setSelected) {
  return useCallback(
    async (o, kind, value) => {
      try {
        if (kind === "status") {
          if (value === "batal" && !window.confirm(`Batalkan pesanan #${o.order_no}?`)) return;
          const upd = await req("patch", `/staff/orders/${o.id}/status`, { status: value });
          setSelected?.((s) => (s && s.id === o.id ? { ...s, ...upd } : s));
          toast.success(`#${o.order_no} dikemaskini`);
        } else if (kind === "loyverse") {
          const r = await req("post", `/staff/orders/${o.id}/loyverse`);
          toast.success(`Masuk Loyverse ${r.loyverse_receipt || ""}`);
        } else if (kind === "mark-loyverse") {
          await req("post", `/staff/orders/${o.id}/mark-loyverse`);
          toast.success("Ditanda sudah masuk Loyverse");
        } else if (kind === "resend-wa") {
          await req("post", `/staff/orders/${o.id}/resend-wa`);
          toast.success("WhatsApp dihantar semula");
        }
      } catch (e) {
        toast.error(errMsg(e));
      }
      reload();
    },
    [req, reload, setSelected]
  );
}
